var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./OpenAnotherShiftModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-03619d29!../../node_modules/vue-loader/lib/selector?type=template&index=0!./OpenAnotherShiftModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/OpenAnotherShiftModal.vue
// module id = 444
// module chunks = 1